import React from "react";
import styled from "styled-components";

interface Props {
    label: string;
    nextLocation: string;
    disabled?: boolean;
    handleNextLocation?: any;
}

const LeftRailOption = ({
    label,
    nextLocation,
    disabled,
    handleNextLocation
}: Props) => {
    const disabledClass = disabled ? "disabled " : ""
    const activeClass = nextLocation === window.location.pathname ? "selected " : ""

	return (
		<StyledOption className={disabledClass + activeClass} disabled={disabled}
            onClick={() => !disabled ? handleNextLocation(nextLocation) : ''}>
			{label}
		</StyledOption>
	);
};

export default LeftRailOption;

const StyledOption = styled.button`
    display: block;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    font-family: museo-sans;
    font-size: 13px;
    line-height: 16px;
    font-weight: 700;
    color: #333;
    &:hover {
        color: #000;
    }
    &.selected {
        color: #E81111;
    }
    &.selected:hover {
        color: #B90000;
    }
    &.disabled {
        color: #919191;
        cursor: initial;
        font-weight: 500;
    }
`;
